var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { fontWeights } from 'syf-component-library/defaultTheme';
import Button from 'syf-component-library/ui/atoms/Button';
import TabTrap from 'syf-component-library/helpers/TabTrap';
const DialogTitleContainer = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin: 0;
  padding: 10px;
  background-color: inherit;
  color: black;
  font-weight: ${fontWeights.semiBold};
`;
export const DialogContent = styled.div `
  padding: 10px;
  color: black;
  outline: none;
  display: flex;
  flex-direction: column;
  background-color: inherit;
  flex-grow: 1;
`;
export const DialogFooter = styled.div `
  padding-top: 10px 30px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
`;
export const DialogButton = styled(Button) `
  height: 32px;
  text-align: center;
  margin: 10px;
`;
export const DialogTitle = ((props) => {
    return (React.createElement(DialogTitleContainer, { role: "heading", "aria-level": 2, id: props.id }, props.children));
});
// darkened overlay styles - need to use pseudo element
export const Overlay = styled.div `  
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    padding: 0;
    margin: 0;
    background-color: rgba(255,255,255,0.8);
`;
export const Container = styled.div `
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 0;
  margin: 0;
  overflow: auto;
`;
const modalWrapperHeight = (props) => props.height ? `@media all and (-ms-high-contrast:none) { height: ${props.height}px; }` : 'height: auto;';
const modalDefaultBackground = (wrapperProps) => {
    if (!wrapperProps.noBackground) {
        return `
      background-color: ${wrapperProps.theme.AgentConversationBackground};
      opacity: 1;
      box-shadow: -1px 2px 15px 1px rgba(0,0,0,0.4);
      border-radius: 10px;
    `;
    }
};
export const ModalWrapper = styled.div `
  overflow: none;
  ${modalDefaultBackground}
  margin: auto;
  width: auto;
  display: flex;  
  flex-direction: column;
  align-content: stretch;
  padding: 0;
  box-sizing: border-box;
  ${modalWrapperHeight}
  & > div { 
    display: flex;
    flex-direction: column;
    align-content: stretch;
    flex-grow: 1;
   }
`;
const ModalDialog = (_a) => {
    var { id, children, header, className, footer } = _a, props = __rest(_a, ["id", "children", "header", "className", "footer"]);
    const dialogProps = {
        'aria-label': props.ariaLabel,
        'aria-labelledby': props.ariaLabelledBy,
        'aria-describedby': props.ariaDescribedBy,
    };
    return (React.createElement(Overlay, null,
        React.createElement(Container, null,
            React.createElement(ModalWrapper, Object.assign({}, props, dialogProps, { role: "dialog", tabIndex: -1, id: id, className: className }),
                React.createElement(TabTrap, null,
                    React.createElement(React.Fragment, null,
                        header,
                        children,
                        footer))))));
};
export default ModalDialog;
